export const MENU_ITEM_NAME = 'Menu Item Name';
export const RESTAURANT_ID  ='UP96mqCChsVzWKVzSSpK';